
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import Qrcode from '@xt/www/components/showQrcode/index.vue'
import { type OpenMiniProgrmOption, openMiniProgram } from '@xt/client/utils/mini'

@Component({
  components: {
    Qrcode
  }
})
export default class ShowQrcodePop extends Vue {
  @Prop({ required: true }) visible: boolean
  @Prop({ default: '' }) url: string
  @Prop({
    default: () => ({})
  })
  generatorParams: {
    path: string
    alias: string
  }
  @Prop({ default: 'buy' }) scanType: 'view' | 'buy'
  @Prop() openMiniProgrmOption: OpenMiniProgrmOption

  get jumpMiniPath() {
    if (this.url) return this.openMiniProgrmOption.path

    return (this.generatorParams.path +=
      this.generatorParams.path.indexOf('?') === -1 ? `?alias=${this.generatorParams.alias}` : `&alias=${this.generatorParams.alias}`)
  }

  @Emit('closed')
  onClosed() {}

  @Emit('close')
  onClose() {}

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}

  async handleOpenPCMini() {
    if (!this.jumpMiniPath) return

    const { miniProgrmType } = this.openMiniProgrmOption
    const { success, reason } = await openMiniProgram(miniProgrmType, `/${this.jumpMiniPath}`)

    console.warn(success, reason)

    if (reason) {
      this.$message.error(reason)
    }
  }
}
